import { DateTime } from 'luxon';
import { DATE_FORMATS } from '../config/constants';

export function formatDate(isoDate, format) {
  return DateTime.fromISO(isoDate).toFormat(DATE_FORMATS[format]);
}

export function calcPeriod(startIso, endIso = null) {
  const start = DateTime.fromISO(startIso);
  const end = endIso ? DateTime.fromISO(endIso) : DateTime.now();
  const { years, months } = end.diff(start, ['years', 'months']).toObject();
  const y = Math.floor(years);
  const m = Math.floor(months);
  if (y && m) return `${y}y ${m}m`;
  if (y) return `${y}y`;
  return `${m}m`;
}
